import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  status: number | null,
  onActionEditar: (idInspecaoObra: number | null, openState: boolean) => void;
  onActionDeletar: (idInspecaoObra: number | null, openState: boolean) => void;
  onActionCopy: (idInspecaoObra: number | null, openState: boolean) => void;
  onEnterInspecaoObra: (idInspecaoObra: number, openNewTab: boolean) => void;
};

export const GenerateMaquinasEquipItensControleColumnDefs = ({
  status,
  onActionEditar,
  onActionDeletar,
  onActionCopy,
  onEnterInspecaoObra,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Em Aberto";
      case 1:
        return "Encerrada";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "red";
      default:
        return "blue";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      width: 90,
      sortable: false,
      renderCell: (params) => (
        <div className="w-[5.25rem] h-full flex justify-center items-center">
          <LargeItemStatus title={computeItemStatusTitle(params.value)} color={computeItemStatusColor(params.value)} description="" />
        </div>
      ),
    },
    {
      field: "dataInspecao",
      filterable: false,
      headerName: "Data de Abertura",
      width: 120, 
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value ? dayjs(value).format("DD/MM/YYYY") : null}
          </div>
        );
      },
    },
    {
      field: "dataEncerramento",
      filterable: false,
      headerName: "Data de Encerramento",
      width: 140, 
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {params.value && dayjs(params.value).format("DD/MM/YYYY")}
          </div>
        );
      },
    },
    {
      field: "nomeMaquinaEquip",
      filterable: false,
      headerName: "Nome da Máquina/Equipamento",
      flex: 1, 
      minWidth: 250,
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "codigoMaquinaEquipamento",
      filterable: false,
      headerName: "Código do Patrimônio",
      width: 130,
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "totalNA",
      headerName: "Total (NA)",
      filterable: false,
      sortable: false,
      width: 90,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "totalA",
      headerName: "Total (A)",
      filterable: false,
      sortable: false,
      width: 80,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
           <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "totalP",
      headerName: "Total (P)",
      filterable: false,
      sortable: false,
      width: 80, 
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
           <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "totalC",
      headerName: "Total (C)",
      filterable: false,
      sortable: false,
      width: 80,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
           <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "totalPA",
      headerName: "Total (PA)",
      filterable: false,
      sortable: false,
      width: 90, 
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
           <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "totalCA",
      headerName: "Total (CA)",
      filterable: false,
      sortable: false,
      width: 90, 
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
           <div className="w-full h-full flex justify-center items-center text-center text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "idMaquinaEquip",
      filterable: false,
      headerName: "Itens da Verificação",
      sortable: false,
      width: 150, 
      valueGetter: (_, row) => {
        return row["idInspecaoMaquinaEquip"] as number;
      },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterInspecaoObra(value, true);
                } else {
                  onEnterInspecaoObra(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".2rem solid #d84a38",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
              }}
            >
              Itens da Verificação
            </Button>
          </div>
        );
      },
    },
    {
      field: "copiar",
      sortable: false,
      filterable: false,
      headerName: "Copiar",
      width: 70, // Slightly increased from 65
      valueGetter: (_, row) => row["idInspecaoMaquinaEquip"] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              disabled={status === 1}
              onClick={() => {
                onActionCopy(params.value, true);
              }}            >
              <DynamicIcon nameIcon="ContentCopy" size={25} className={status === 0 ? "text-purple-500" : "text-gray-400"} />
            </IconButton>
          </div>
        );
      },
    },
    {
      field: "idInspecaoMaquinaEquip",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton
            disabled={status === 1}
            onClick={() => onActionEditar(params.row.idInspecaoMaquinaEquip, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="text-gray-400" />
          </IconButton>

          <IconButton
            disabled={status === 1}
            onClick={() => onActionDeletar(params.row.idInspecaoMaquinaEquip, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className={status === 0 ? "text-red-500" : "text-gray-200"} />
          </IconButton>
        </div>
      ),
    },
  ];
};